const $ = jQuery

export default class SmoothScroll {
  constructor () {
    this.initScroll()
    this.urlHashScroll()
  }

  initScroll () {
    const _this = this
    $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault()
      _this.scroll($.attr(this, 'href'))
    })
  }

  scroll (element) {
    const _this = this
    if (_this.elementExists(element) !== null) {
      $('html, body').animate({
        scrollTop: $(element).offset().top - _this.getHeaderHeight()
      }, 800)
    }
  }

  elementExists (href) {
    return document.getElementById(href.replace('#', ''))
  }

  getHeaderHeight () {
    let height = 0
    const HEADER = document.getElementById('main_header')
    HEADER && (height += HEADER.getBoundingClientRect().height)
    const ADMIN_BAR = document.getElementById('wpadminbar')
    ADMIN_BAR && (height += ADMIN_BAR.getBoundingClientRect().height)
    return height
  }

  urlHashScroll () {
    const hash = window.location.hash
    if (hash !== '') {
      this.scroll(hash)
      window.history.pushState('hash', '', window.location.href.split('#')[0])
    }
  }
}
